import script from "./TransactionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionModal.vue?vue&type=script&setup=true&lang=js"

import "./TransactionModal.vue?vue&type=style&index=0&id=6ddd5033&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ddd5033"]])

export default __exports__